import { createSlice } from '@reduxjs/toolkit'
import { getServices, ServiceType } from '../../actions/servicesAction'

export interface IServices {
  services: ServiceType[]
  error: any
  isLoading: boolean
}

const initialState: IServices = {
  services: [],
  isLoading: false,
  error: '',
}

export const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    clearServicesError: (state) => {
      state.error = ''
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getServices.pending, (state) => {
      state.isLoading = true
      state.error = ''
    })
    builder.addCase(getServices.fulfilled, (state, action) => {
      state.isLoading = false
      state.services = action.payload
      state.error = ''
    })
    builder.addCase(getServices.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
  },
})

export const { clearServicesError } = servicesSlice.actions

export const servicesReducer = servicesSlice.reducer
